import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-government-list',
  templateUrl: './government-list.component.html',
  styleUrls: ['./government-list.component.sass']
})
export class GovernmentListComponent implements OnInit {
  items;
  colId;
  territory;
  categoryInstitution;
  governmentCol;
  logoImage: string = "./assets/img/no-logo.png"

  constructor(    
    private route: Router,
    private aroute: ActivatedRoute,
    public db: FirestoreService
  ) { }

  ngOnInit(): void {
    // console.log('territory: '+history.state.territory)
    // console.log('category: '+history.state.category)

    //this.territory = history.state.territory;
    //this.categoryInstitution = history.state.categoryInstitution;
    this.categoryInstitution = this.aroute.snapshot.paramMap.get('id');

    console.log(`this.categoryInstitution: ${this.categoryInstitution}`);   
    

    //this.items = this.db.getGovernmentCol(this.colId);
    this.governmentCol = this.db.getMainColOrderWhere('governments', 'name', 'categoryInstitution', this.categoryInstitution)
  };

  // Route
  routeToGovernmentDetailPage(docId){
    this.route.navigateByUrl('government/'+docId);
  };

}